import { CRUDApiService } from "./impl/CRUDApiService";

export class CapsulesApiService extends CRUDApiService {
  constructor() {
    super('capsules');
  }
}
